const TeamTabContentStyles = {
  teamTabContentWrapper: {},
  chips: {
    background: "red",
  },
};

export default TeamTabContentStyles;
